import { Button, ButtonProps } from "@chakra-ui/react"
import * as React from "react"
import { Icon } from "./icon"
import { VscArrowRight, VscArrowLeft } from "react-icons/vsc"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"

interface CircleArrowIconProps extends ButtonProps {
  directionIcon: "right" | "left"
}

const _CircleArrowIcon: React.FC<CircleArrowIconProps> = props => {
  const { directionIcon, ...otherProps } = props
  const roomStyles = useRecoilValue(brandingSelector)
  return (
    <Button
      justifyContent="center"
      alignItems="center"
      color={roomStyles?.badgeButtonTextColor ?? "white"}
      minW="0px"
      height={"unset"}
      bg={roomStyles?.badgeButtonBackgroundColor ?? "gray.400"}
      padding={0}
      opacity="0.75"
      borderRadius="50%"
      fontSize="2rem"
      {...otherProps}
      _focus={{}}
      _hover={{}}
    >
      <Icon
        padding="3px"
        fontSize="2rem"
        src={directionIcon === "right" ? VscArrowRight : VscArrowLeft}
      />
    </Button>
  )
}

export const CircleArrowIcon = React.memo(_CircleArrowIcon)
